<sc-sub-title>{{ dictionaryKey | translate:[dictionaryKey, translationService.language] }}</sc-sub-title>